import { validator } from "@/utils/validator";

export const loginSchema = validator.object().shape({
  email: validator.string().emptyToNull().max(60).label("メールアドレス").required(),
  password: validator.string().emptyToNull().label("パスワード").required(),
});
